import { DEFAULT_HEADER, JWT_TOKEN, MEMB_NO, ADMIN_KIND } from '../const';

export default function authHeader() {
    return {
        ...DEFAULT_HEADER,
        Authorization: localStorage.getItem(JWT_TOKEN) || '',
        //membNo: 'MEMB00000013',
        //adminKind: 'CM00010002',
        membNo: localStorage.getItem(MEMB_NO) || '',
        adminKind: localStorage.getItem(ADMIN_KIND) || ''
    };
}
